<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="create_expense" />
    <CreateExpensesFrom
      :referenceno="referenceno"
      :date="date"
      :categories="categories"
      :warehouses="warehouses"
      :form="form"
      :is-loading="isLoading"
      :is-edit-mode="isEditMode"
      @update:referenceno="referenceno = $event"
      @update:date="date = $event"
      @update:field="(field, value) => form[field] = value"
      @generate-reference="fetchNextRef"
      @open-category-modal="openCategoryModal"
      @submit="submitExpense"
    />
    <CreateCategoryModal
      :form="categoryForm"
      :loading="isCategorySaving"
      :is-edit-mode="isCategoryEditMode"
      @update-field="updateCategoryField"
      @generate-code="generateCategoryCode"
      @submit="submitCategory"
    />
    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import CreateExpensesFrom from "../../components/Expenses/CreateExpenses/CreateExpensesFrom.vue";
import CreateCategoryModal from "../../components/Expenses/ExpenseCategory/CreateCategoryModal.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import { useExpenseForm } from "../../composables/useExpenseForm";

export default defineComponent({
  name: "CreateExpensesPage",
  components: {
    MainHeader,
    MainSidebar,
    BreadcrumbMenu,
    CreateExpensesFrom,
    CreateCategoryModal,
    MainFooter,
  },
  setup() {
    return useExpenseForm();
  },
});
</script>
